import { css } from '@emotion/react';
import { removeParamsFromUrl } from '@zapier/url-utils';

import { Alert, Link, Text } from '@zapier/design-system';
import { useTranslations } from 'next-intl';

import { AuthLayout } from '../AuthLayout';

type Props = {
  error: string | undefined | null;
  url: string;
};

const rootStyle = css`
  display: grid;
  grid-gap: 20px;
`;

const buttonStyle = css`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 20px;
`;

// `Link` renders inline-flex and has no `isFullWidth`, so stretch it to fill its
// grid column the way the button-styled links it replaces used to.
const fullWidthLinkStyle = css`
  width: 100%;
  justify-content: center;
`;

function humanReadableError(error: string) {
  if (error.includes('Not a valid UUID')) {
    return 'Could not find invitation';
  }

  return error;
}

export function InvitationError({ error, url }: Props) {
  const t = useTranslations('invitation-error');
  const query = url.split('?')?.[1] || '';
  const params = removeParamsFromUrl(`?${query}`, ['invitation']);

  const errorMessage = error
    ? humanReadableError(error)
    : 'This invitation is no longer valid';

  return (
    <AuthLayout promo={null} showPromo={false} title={null}>
      <div css={rootStyle}>
        <Text tag="h1" type="PageHeader" color="GrayWarm10">
          {t('heading')}
        </Text>
        <Text tag="h2" type="SectionHeader" color="GrayWarm10">
          {t('subheading')}
        </Text>
        <div />
        <Alert status="error">{errorMessage}</Alert>
        <div />
        <div css={buttonStyle}>
          <Link
            css={fullWidthLinkStyle}
            href={`/sign-up${params}`}
            variant="primary"
            size="small"
          >
            {t('sign-up')}
          </Link>
          <Link
            css={fullWidthLinkStyle}
            href={`/app/login${params}`}
            variant="secondary"
            size="small"
          >
            {t('log-in')}
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
}
